import p5 from "p5";
let frameElapseMaxInterval = 100;
let minSignalThreshold = 20;


let xIncrement = 15;
let yIncrement = 15;
let oscillationScalar = 3;
const strengthIncrement = 0.1;
const maxPointSize = 8;



class PressingStudy {



    constructor(sketch, w, h, ps, dp) {
        this.sketch = sketch;
        this.w = w;
        this.h = h;
        this.dp = dp;

        this.ps = ps;
        this.particles = ps.systemParticles();

        this.maxDistanceFromEpicenter = w;

        this.strengths = [];
        this.oscillations = [];
        this.sizes = [];
        this.oscillationsY = [];

        for (let i = 0; i < this.particles.length; i++) {
            this.strengths[i] = 0;
            this.oscillations[i] = 0;
            this.oscillationsY[i] = 0;
            this.sizes[i] = 0;
        }

        this.center = this.sketch.createVector(w / 2, h / 2);

        this.frameStart = this.sketch.frameCount;

        this.phaseNumber = 1;


    }

    draw() {

        this.sum = this.dp.sum();




        for (let mi = 0; mi < this.ps.systemParticles().length; mi++) {
            let p = this.ps.systemParticles()[mi];
            let i = p.index;
            let px = p.cx;
            let py = p.cy;
            let s = this.strengths[mi];
            let size = this.sizes[mi];

            let rx = 0;
            let ry = 0;
            let distanceFromEpicenter = this.sketch.dist(this.center.x, this.center.y, px, py);
            let strength = 0;
            if (this.sum > 0) {
                strength = this.sketch.max(0, 1 - (distanceFromEpicenter / (this.sum * 3)));
            }



            if (this.phaseNumber == 1) {


                if (this.sum >= 10) {
                    // Calculate distance of polet from epicenter

                    let scaledMaxDistanceFromEpicenter = this.maxDistanceFromEpicenter * this.sketch.constrain(this.sum / 1000, 0, 1);

                    let distanceStrength = this.sketch.max(0, 1 - (distanceFromEpicenter / scaledMaxDistanceFromEpicenter));
                    let strengthAddition = distanceStrength * strengthIncrement;
                    let newStrengthValue = this.sketch.constrain(s + strengthAddition, 0, 1);
                    this.strengths[i] = newStrengthValue;

                    // console.log("ss", this.maxDistanceFromEpicenter, distanceStrength, strengthAddition, newStrengthValue);

                    let newSizeValue = this.sketch.constrain(size + strengthAddition, 0, maxPointSize);


                    this.sizes[i] = newSizeValue;
                }

                // Slow decay of opacity
                this.strengths[i] -= 0.0005;
                this.sizes[i] -= 0.0005;

                p.updateOpacity(this.strengths[i] * 80);
                p.updateSize(this.sizes[i]);



            } else if (this.phaseNumber == 2) {


                rx = Math.sin((this.sketch.this.sketch.frameCount - i * 10) / 20.0) * (0 + this.strength * 10);
            } else if (this.phaseNumber == 3) {
                ry = Math.sin((this.sketch.frameCount - i * 10) / 20.0) * (0 + this.strength * 10);
            } else if (this.phaseNumber == 4) {
                rx = Math.sin((this.sketch.frameCount - i * 10) / 20.0) * (0 + this.strength * 10);
                ry = Math.sin((this.sketch.frameCount - i * 30) / 20.0) * (0 + this.strength * 10);
            }

            p.updatePosition(rx, ry);


            if (p.isOscillationX || p.isOscillationY) {

                p.updateOscillationPosition();
            }

        }

        this.ps.render();
    }


    reset() {

        for (let i = 0; i < this.particles.length; i++) {
            this.strengths[i] = 0;
            this.oscillations[i] = 0;
            this.oscillationsY[i] = 0;
            this.sizes[i] = 0;
        }

        this.frameStart = this.sketch.frameCount;

        this.phaseNumber = 1;

    }


    moveCenter(x, y) {
        this.center = this.sketch.createVector(x, y);
    }



    pushPhase() {

        if (this.phaseNumber < 4) {

            this.phaseNumber += 1;
        } else {

            this.phaseNumber = 1;

        }

    }



}

export default PressingStudy;